// staleTime defaults per docs/ui/operator-ui-tds.md §6.2.
// Per-query overrides at the useQuery call site for surfaces that need stricter freshness
// (lock query: staleTime 0 — handled at the query definition site by NEX-148).

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
});
